import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { ProblemSolution } from './components/ProblemSolution';
import { Transformations } from './components/Transformations';
import { WhatYouLearn } from './components/WhatYouLearn';
import { IsForYou } from './components/IsForYou';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-brown selection:bg-accent selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ProblemSolution data-id="element-5" />
        <Transformations data-id="element-6" />
        <WhatYouLearn data-id="element-7" />
        <IsForYou data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Bonuses data-id="element-10" />
        <PurchaseSection data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}